import axios from "axios";
import { url } from "components/common/api";

const ACCESS_TOKEN_KEY = "userToken";
const REFRESH_TOKEN_KEY = "refreshToken";

const accessTokenListeners = new Set();
const forcedLogoutListeners = new Set();

const refreshClient = axios.create({
  baseURL: url,
  headers: { "Content-Type": "application/json" },
});

let refreshPromise = null;

const notifyAccessTokenChange = (token) => {
  accessTokenListeners.forEach((listener) => {
    try {
      listener(token);
    } catch (err) {
      console.error("access token listener failed", err);
    }
  });
};

const notifyForcedLogout = () => {
  forcedLogoutListeners.forEach((listener) => {
    try {
      listener();
    } catch (err) {
      console.error("forced logout listener failed", err);
    }
  });
};

export const getAccessToken = () => localStorage.getItem(ACCESS_TOKEN_KEY) || "";

export const setAccessToken = (token) => {
  if (token) {
    localStorage.setItem(ACCESS_TOKEN_KEY, token);
  } else {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
  }
  notifyAccessTokenChange(token || "");
};

export const getRefreshToken = () =>
  localStorage.getItem(REFRESH_TOKEN_KEY) || "";

export const setRefreshToken = (token) => {
  if (token) {
    localStorage.setItem(REFRESH_TOKEN_KEY, token);
  } else {
    localStorage.removeItem(REFRESH_TOKEN_KEY);
  }
};

export const clearTokens = () => {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
  notifyAccessTokenChange("");
};

export const refreshAccessToken = async () => {
  const refreshToken = getRefreshToken();
  if (!refreshToken) {
    throw new Error("Missing refresh token");
  }

  if (!refreshPromise) {
    refreshPromise = refreshClient
      .post("/api/token/refresh/", { refresh: refreshToken })
      .then(({ data }) => {
        if (!data?.access) {
          throw new Error("Refresh response missing access token");
        }
        setAccessToken(data.access);
        return data.access;
      })
      .finally(() => {
        refreshPromise = null;
      });
  }

  return refreshPromise;
};

export const subscribeToAccessToken = (listener) => {
  accessTokenListeners.add(listener);
  return () => accessTokenListeners.delete(listener);
};

export const subscribeToForcedLogout = (listener) => {
  forcedLogoutListeners.add(listener);
  return () => forcedLogoutListeners.delete(listener);
};

export const emitForcedLogout = () => {
  notifyForcedLogout();
};

